import type { ChartWordCloudBasis, ChartWordCloudItem } from "./types";

const WORD_CLOUD_SIZE_VARIANT_COUNT = 7;

function getWordCloudPrefix(basis?: ChartWordCloudBasis) {
  switch (basis) {
    case "hashtags":
      return "#";
    case "mentions":
      return "@";
    default:
      return "";
  }
}

export function scaleWordCloudValues(
  words: ChartWordCloudItem[],
  minScale: number = 14,
  maxScale: number = 72,
  basis?: ChartWordCloudBasis,
): Array<{ text: string; value: number; originalKeyword?: string }> {
  if (words.length === 0) {
    return [];
  }

  const counts = words.map((word) => word.count);
  const minCount = Math.min(...counts);
  const maxCount = Math.max(...counts);
  const minRoot = Math.sqrt(Math.max(minCount, 0));
  const maxRoot = Math.sqrt(Math.max(maxCount, 0));
  const scaleRange = Math.max(maxScale - minScale, 0);
  const hasRange = maxRoot > minRoot;
  const variantRange = WORD_CLOUD_SIZE_VARIANT_COUNT - 1;
  const prefix = getWordCloudPrefix(basis);

  return words.map((word) => {
    const rootCount = Math.sqrt(Math.max(word.count, 0));
    const normalized = hasRange
      ? (rootCount - minRoot) / (maxRoot - minRoot)
      : 1;
    const variantIndex = hasRange
      ? Math.round(normalized * variantRange)
      : Math.ceil(variantRange / 2);
    const fontSize = minScale + (variantIndex / variantRange) * scaleRange;
    const value = fontSize * fontSize;
    const text =
      !prefix || word.keyword.startsWith(prefix)
        ? word.keyword
        : `${prefix}${word.keyword}`;

    return {
      text,
      value,
      originalKeyword: word.originalKeyword,
    };
  });
}
